var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "196px",
    height: "196px",
    viewBox: "0 0 196 196",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M68 136C105.555 136 136 105.555 136 68C136 30.4446 105.555 0 68 0C30.4446 0 0 30.4446 0 68C0 105.555 30.4446 136 68 136Z",
    transform: "translate(0.20820376 0.48980457)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "matrix(-0.70710677 -0.70710677 0.70710677 -0.70710677 97.581055 194.45435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 136C105.555 136 136 105.555 136 68C136 30.4446 105.555 0 68 0C30.4446 0 0 30.4446 0 68C0 105.555 30.4446 136 68 136Z",
    transform: "translate(0.20820376 0.48980457)",
    id: "Mask",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(-9.569971 -10.874156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(0.1624745 0.20194711)",
    id: "Rectangle",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(10.299563 0.20194711)",
    id: "Rectangle",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(19.591896 0.20194711)",
    id: "Rectangle-Copy-3",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(29.728985 0.20194711)",
    id: "Rectangle-Copy-4",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(39.866074 0.20194711)",
    id: "Rectangle-Copy-5",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(49.158405 0.20194711)",
    id: "Rectangle-Copy-6",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(59.295494 0.20194711)",
    id: "Rectangle-Copy-7",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(69.43259 0.20194711)",
    id: "Rectangle-Copy-8",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(78.724915 0.20194711)",
    id: "Rectangle-Copy-9",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(88.86201 0.20194711)",
    id: "Rectangle-Copy-10",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(98.99909 0.20194711)",
    id: "Rectangle-Copy-11",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(107.44667 0.20194711)",
    id: "Rectangle-Copy-12",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(118.42851 0.20194711)",
    id: "Rectangle-Copy-13",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(127.72085 0.20194711)",
    id: "Rectangle-Copy-14",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.68951 0L1.68951 145.735L0 145.735L0 0Z",
    transform: "translate(137.85794 0.20194711)",
    id: "Rectangle-Copy-14",
    fill: "#F77A56",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65);
export default __webpack_public_path__ + "static/media/65.766ce45cb69a10c22aaadc4bc26747f9.svg";
export { ForwardRef as ReactComponent };